import { Component, OnInit } from '@angular/core';
import { ForgetPassword } from './forget';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../../environments/environment';
import { alert } from 'devextreme/ui/dialog';
import { Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { AuthService } from '../auth-service.service';


@Component({
  selector: 'ngx-auth-forget',
  templateUrl: './auth-forget.component.html',
  styleUrls: ['./auth-forget.component.scss']
})
export class AuthForgetComponent implements OnInit {
  errors: string[] = [];
  user: ForgetPassword = new ForgetPassword();
  submitted: boolean;
  culture: string;

  constructor(private http: HttpClient, private _router: Router,
    private _translateService: TranslateService, private _authService: AuthService
  ) { }

  ngOnInit() {
    this.culture = this._authService.getCulterByLanguage();
  }


  reset(): void {

    this.submitted = true;
    this.http.post(environment.API_URL + 'user/forgetpassword?culture=' + this.culture, this.user)
      .subscribe(
        response => {
          this.submitted = false;
          alert(this._translateService.instant('WACHTWOORD_VERGETEN.MELDING.OPNIEUW_INGESTELD'), this._translateService.instant('WACHTWOORD_VERGETEN.MELDING.TITEL_OPNIEUW_INGESTELD')).then(data => {
            this._router.navigate(['auth', 'login']);
          });
        },
        error => {
          this.submitted = false;

          if (Array.isArray(error.error)) {
            this.errors = error.error;
          } else if (!!error.error.Message) {
            var message = error.error.Message;;
            this.errors[0] = message;
          } else {
            this.errors[0] = this._translateService.instant('WACHTWOORD_VERGETEN.MELDING.TECHNISCHE_FOUT');
          }
          this.submitted = false;
        });
  }

}
